// Live, public, unauthenticated API surface (60s server cache, 120 req/min per IP).
// Single source for every page that queries the real engine — ComparePage and the homepage
// hero card fetch the same /public endpoints, so the marketing site shows live data, not demos.
export const PUBLIC_BASE = (
  import.meta.env.VITE_API_BASE ?? 'https://schedulesmcp-api.fly.dev/v1'
).replace(/\/v1\/?$/, '/public')

/**
 * The two endpoints that need a key: /schedules and /schedules/cards.
 *
 * Cards joined on 16 September, in the same change that put a key on it. That pairing is load-bearing:
 * while cards was open, routing it through the site would have replaced every visitor's own address
 * with a Cloudflare colo IP at the API's per-address daily cap, one bucket for the whole site instead
 * of one each. `/covered` and `/carriers` stay open and stay on PUBLIC_BASE.
 *
 * Same origin as the page, never the API host. The key lives at the edge (apps/web/site-api.js) and
 * the browser never sees it, because a key in a bundle is a key anyone can read. In `bun dev` the same
 * path is proxied by vite, which reads the key from the shell rather than from import.meta.env, so a
 * developer's key does not end up in the dev bundle either.
 *
 * Everything else on PUBLIC_BASE stays open and must keep going straight to the API: sending free
 * answers through here would spend our key on them.
 */
export const KEYED_BASE = '/site-api'
